// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13Hr3","colBig":"styles_colBig__VhNpK","colSmall":"styles_colSmall__3cgrp"};